import { Stack, Text } from '@mantine/core';

import { BookValidationAction } from '@/module/Author/Book/Validation/BookValidationAction';
import { BookValidationHistory } from '@/module/Author/Book/Validation/BookValidationHistory';
import { BookDeleteButton } from '@/module/Author/Book/components/BookDeleteButton';
import { PublicationContent } from '@/module/Author/Publication/components/PublicationContent';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList, BdiList, PublicationPages, PublisherLink } from '@feature/utils';

import { ViewCitationsButton } from '../Citation/components/ViewCitationsButton';
import { BookProofAction } from './Proof';
import { Book } from './model/BookTypes';

interface BookViewProps {
  book: Book;
}

export function BookView({ book }: BookViewProps) {
  const { authors, noOfPages, publisher, startPage, endPage, publisherType, bdis } = book;

  return (
    <Stack>
      <PublicationContent
        publication={book}
        authorsNo={authors.length}
        editAction={
          <EditButtonLink
            size="xs"
            miw="100px"
          />
        }
        deleteAction={<BookDeleteButton bookId={book.id} />}
      />
      <ViewCitationsButton
        entityId={book.id}
        entityType="BOOK"
      />
      <Content type="full">
        <Stack gap="xs">
          {publisher && (
            <PublisherLink
              publisherId={publisher.id}
              title={publisher.title}
            />
          )}
          {publisherType && <Text>Tip editura: {publisherType.name}</Text>}
          <PublicationPages
            noOfPages={noOfPages ?? 0}
            endPage={endPage ?? 0}
            startPage={startPage ?? 0}
          />
          <BdiList bdis={bdis} />
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <BookProofAction
        bookId={book.id}
        authors={authors}
      />
      <BookValidationAction bookId={book.id} />
      <BookValidationHistory bookId={book.id} />
    </Stack>
  );
}
